import { FaCoins } from "react-icons/fa";

import "./CommandLarge.css";

interface Props {
    title: string;
    desc: string;
    input: string | null;
    price: number | null;
}

export function CommandLarge({ title, desc, input, price }: Props) {
    return (
        <tr className="command-large-row">
            <td className="search-data-col">
                <div className="search-data-title">
                    !{title}
                    <span className="price-span show-on-mobile">
                        <FaCoins />
                        {" " + price}
                    </span>
                </div>
                <p className="search-data-mobile-desc show-on-mobile">
                    Desc: {desc}
                </p>
                <p className="search-data-mobile-input show-on-mobile">
                    Input: {input}
                </p>
            </td>
            <td className="search-data-col hide-on-mobile">{desc}</td>
            <td className="hide-on-mobile">{input}</td>
            <td className="hide-on-mobile">{price}</td>
        </tr>
    );
}
